import React from 'react';
import Participant from './Participant';

export default ({ event, participants }) => {
    const participant = (event) => participants[event.participant_id];

    return (
        <div className="event__panel">
            <div className="event__description">
                <strong>Goal!</strong>
                {' Scored by '}
                <Participant participant={participant(event)}/>
            </div>
            {renderAssists()}
            {renderNotes()}
        </div>
    );

    function renderAssists() {
        if (event.children.length) {
            return (
                <div className="event__aux">
                    {'Assisted by '}
                    <ul className="list-sentence">
                        {event.children.map((child) => (
                            <li key={child.id}><Participant participant={participant(child)}/></li>
                        ))}
                    </ul>
                </div>
            );
        }
    }

    function renderNotes() {
        if (event.notes) {
            return <div className="event__notes">“{event.notes}”</div>;
        }
    }
};
